<template>
  <v-card class="dialog">
    <v-card-title class="mb-4 primary">
      <h3 class="headline white--text">SOLICITAÇÃO DE COTAÇÃO</h3>
      <v-spacer></v-spacer>
      <v-btn icon flat class="ma-0" title="Fechar" @click.prevent="$emit('fechar')">
        <v-icon color="white">close</v-icon>
      </v-btn>
    </v-card-title>

    <v-container grid-list-lg>
      <v-layout row wrap>
        <v-flex xs2 md2>
          <v-flex xs12 md12>
            <v-btn
              block
              class="btn-side-tabsCustom"
              :class="aba === 1 ? 'active' : ''"
              @click="aba = 1"
            >DADOS</v-btn>
          </v-flex>
          <v-flex xs12 md12>
            <v-btn
              block
              class="btn-side-tabsCustom"
              :class="aba === 2 ? 'active' : ''"
              @click="aba = 2"
            >TRATATIVAS</v-btn>
          </v-flex>
        </v-flex>

        <v-flex xs10 md10>
          <div v-show="aba === 1">
            <v-card-text style="min-height: 340px" class="pt-0">
              <v-layout row wrap>
                <v-flex md6 xs12 class="pr-4">
                  <v-text-field label="Razão Social" readonly :value="dados.razaoSocial"></v-text-field>
                </v-flex>
                <v-flex md6 xs12>
                  <v-text-field label="CNPJ" readonly :value="dados.cnpj"></v-text-field>
                </v-flex>
                <v-flex md6 xs12 class="pr-4">
                  <v-text-field label="Nº da Solicitação" readonly :value="dados.numeroReserva"></v-text-field>
                </v-flex>
                <v-flex md6 xs12>
                  <v-text-field label="Status" readonly :value="rotuloStatus"></v-text-field>
                </v-flex>
                <v-flex md6 xs12 class="pr-4">
                  <v-text-field label="Nº da Cotação" readonly :value="dados.idApolice"></v-text-field>
                </v-flex>
                <v-flex md6 xs12>
                  <v-text-field label="Data da Solicitação" readonly :value="dados.dataCriacao"></v-text-field>
                </v-flex>
              </v-layout>
            </v-card-text>
          </div>

          <div v-show="aba === 2">
            <ChatTratativa
              :idCorretorReserva="idCorretorReserva"
              :idApolice="idApolice"
              @carregada="aoCarregar"
              @enviada="aoEnviar"
            ></ChatTratativa>
          </div>
        </v-flex>
      </v-layout>
    </v-container>
  </v-card>
</template>

<script>
import ChatTratativa from "@/components/pages/tratativa/ChatTratativa.vue";
import statusTratativa from "@/helpers/status-tratativa.js";
import usuarioHelper from "@/helpers/usuario-logado.js";

export default {
  name: "ModalTratativaAnalista",

  components: { ChatTratativa },

  props: {
    idCorretorReserva: {
      type: [Number, String],
      default: null,
    },
    idApolice: {
      type: [Number, String],
      default: null,
    },
    dadosSolicitacao: {
      type: Object,
      default: () => ({}),
    },
    abaInicial: {
      type: Number,
      default: 2,
    },
  },

  data() {
    return {
      aba: this.abaInicial,
      tratativa: {},
    };
  },

  computed: {
    dados() {
      return this.dadosSolicitacao || {};
    },
    idPerfil() {
      const usuario = usuarioHelper.USUARIO_LOGADO();
      return usuario && usuario.perfil ? usuario.perfil.id : null;
    },
    rotuloStatus() {
      return statusTratativa.rotuloStatus(this.tratativa.idPropostaStatus, this.idPerfil);
    },
  },

  methods: {
    aoCarregar(tratativa) {
      this.tratativa = tratativa || {};
    },
    aoEnviar(tratativa) {
      this.tratativa = tratativa || {};
      this.$emit("atualizada", tratativa);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/pages/tratativa/ModalTratativaAnalista.vue